// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * UploadedFileAttributes type.
 * @typedef {object} UploadedFileAttributes
 * @property {string} id - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string | null} fileName - Attribute value.
 * @property {string | null} resourceId - Attribute value.
 * @property {string | null} resourceType - Attribute value.
 * @property {string | null} title - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string | null} userId - Attribute value.
 */
/**
 * Attributes accepted by UploadedFileCreateAttributes.
 * @typedef {object} UploadedFileCreateAttributes
 * @property {FrontendModelAttributeValue} [file] - Permitted file value.
 * @property {UploadedFileAttributes["resourceId"] | null} [resourceId] - Permitted resourceId value.
 * @property {UploadedFileAttributes["resourceType"] | null} [resourceType] - Permitted resourceType value.
 * @property {UploadedFileAttributes["title"] | null} [title] - Permitted title value.
 * @property {UploadedFileAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Attributes accepted by UploadedFileUpdateAttributes.
 * @typedef {object} UploadedFileUpdateAttributes
 * @property {FrontendModelAttributeValue} [file] - Permitted file value.
 * @property {UploadedFileAttributes["resourceId"] | null} [resourceId] - Permitted resourceId value.
 * @property {UploadedFileAttributes["resourceType"] | null} [resourceType] - Permitted resourceType value.
 * @property {UploadedFileAttributes["title"] | null} [title] - Permitted title value.
 * @property {UploadedFileAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Frontend model for UploadedFile.
 * @augments {FrontendModelBase<UploadedFileAttributes, UploadedFileCreateAttributes, UploadedFileUpdateAttributes, UploadedFileAttributes["id"], string>}
 */
class UploadedFile extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "UploadedFile",
      attachments: {
        file: {type: "hasOne"},
      },
      attributes: [
        "id",
        "createdAt",
        "fileName",
        "resourceId",
        "resourceType",
        "title",
        "updatedAt",
        "userId",
      ],
      collectionCommands: [
        "createWithFile",
      ],
      memberCommands: [
        "downloadFile",
        "replaceFile",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      user: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      user: "User",
    }
  }

  /** @returns {UploadedFileAttributes["id"]} - Attribute value. */
  id() { return /** @type {UploadedFileAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {UploadedFileAttributes["id"] | null} newValue - New attribute value.
   * @returns {UploadedFileAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {UploadedFileAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {UploadedFileAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {UploadedFileAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {UploadedFileAttributes["fileName"]} - Attribute value. */
  fileName() { return /** @type {UploadedFileAttributes["fileName"]} */ (this.readAttribute("fileName")) }

  /**
   * @param {UploadedFileAttributes["fileName"] | null} newValue - New attribute value.
   * @returns {UploadedFileAttributes["fileName"] | null} - Assigned value.
   */
  setFileName(newValue) { return /** @type {UploadedFileAttributes["fileName"] | null} */ (this.setAttribute("fileName", newValue)) }

  /** @returns {UploadedFileAttributes["resourceId"]} - Attribute value. */
  resourceId() { return /** @type {UploadedFileAttributes["resourceId"]} */ (this.readAttribute("resourceId")) }

  /**
   * @param {UploadedFileAttributes["resourceId"] | null} newValue - New attribute value.
   * @returns {UploadedFileAttributes["resourceId"] | null} - Assigned value.
   */
  setResourceId(newValue) { return /** @type {UploadedFileAttributes["resourceId"] | null} */ (this.setAttribute("resourceId", newValue)) }

  /** @returns {UploadedFileAttributes["resourceType"]} - Attribute value. */
  resourceType() { return /** @type {UploadedFileAttributes["resourceType"]} */ (this.readAttribute("resourceType")) }

  /**
   * @param {UploadedFileAttributes["resourceType"] | null} newValue - New attribute value.
   * @returns {UploadedFileAttributes["resourceType"] | null} - Assigned value.
   */
  setResourceType(newValue) { return /** @type {UploadedFileAttributes["resourceType"] | null} */ (this.setAttribute("resourceType", newValue)) }

  /** @returns {UploadedFileAttributes["title"]} - Attribute value. */
  title() { return /** @type {UploadedFileAttributes["title"]} */ (this.readAttribute("title")) }

  /**
   * @param {UploadedFileAttributes["title"] | null} newValue - New attribute value.
   * @returns {UploadedFileAttributes["title"] | null} - Assigned value.
   */
  setTitle(newValue) { return /** @type {UploadedFileAttributes["title"] | null} */ (this.setAttribute("title", newValue)) }

  /** @returns {UploadedFileAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {UploadedFileAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {UploadedFileAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {UploadedFileAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {UploadedFileAttributes["userId"] | null} newValue - New attribute value.
   * @returns {UploadedFileAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {UploadedFileAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /**
   * Runs createWithFile.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{id: string}>} - Command response.
   */
  static async createWithFile(...commandArguments) {
    return /** @type {{id: string}} */ (await this.executeCustomCommand({
      commandName: "create-with-file",
      commandType: "create-with-file",
      payload: UploadedFile.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs downloadFile.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{contentBase64: string, contentType: string, filename: string}>} - Command response.
   */
  async downloadFile(...commandArguments) {
    return /** @type {{contentBase64: string, contentType: string, filename: string}} */ (await UploadedFile.executeCustomCommand({
      commandName: "download-file",
      commandType: "download-file",
      memberId: this.scalarPrimaryKeyValue("Custom member command UploadedFile#downloadFile"),
      payload: UploadedFile.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: UploadedFile.resourcePath()
    }))
  }

  /**
   * Runs replaceFile.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{id: string}>} - Command response.
   */
  async replaceFile(...commandArguments) {
    return /** @type {{id: string}} */ (await UploadedFile.executeCustomCommand({
      commandName: "replace-file",
      commandType: "replace-file",
      memberId: this.scalarPrimaryKeyValue("Custom member command UploadedFile#replaceFile"),
      payload: UploadedFile.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: UploadedFile.resourcePath()
    }))
  }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<UploadedFile, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<UploadedFile, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(UploadedFile)

export {UploadedFile}

export default UploadedFile
